import { UploadedFile } from './uploaded-file.model';

/** A generic fact whose shape can grow without a database migration. */
export interface InjectionMoldingKnowledgeEntry {
    key: string;
    value: string;
    unit: string;
}

export interface InjectionMoldingMoldChangeLog {
    id: string;
    createdOn: Date;
    createdById: string;
    text: string;
}

/** One physical Injection Molding mold. There is intentionally no family layer. */
export interface InjectionMoldingMold {
    id: string;
    name: string;
    description: string;
    customerId: string;
    owner: string;
    manufacturer: string;
    serialNumber: string;
    assetTag: string;
    status: InjectionMoldingMoldStatus;
    storageLocation: string;
    cavityCount: number;
    totalCycleCount: number;
    notes: string;
    specifications: InjectionMoldingKnowledgeEntry[];
    files: UploadedFile[];
    changeLog: InjectionMoldingMoldChangeLog[];
    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
}

/**
 * The validated knowledge for making one exact product revision in one physical mold.
 * Machine and cycle time live here because both may vary for the same product/mold.
 */
export interface InjectionMoldingMoldSetup {
    id: string;
    moldId: string;
    productId: string;
    productVersionId: string;
    machineAssetId: string;
    status: InjectionMoldingMoldSetupStatus;
    cycleTimeSeconds: number | null;
    activeCavityCount: number | null;
    setupTimeMinutes: number | null;
    processNotes: string;
    startupNotes: string;
    shutdownNotes: string;
    qualityNotes: string;
    packagingNotes: string;
    sourceNotes: string;
    confidence: InjectionMoldingMoldSetupConfidence;
    verifiedById: string;
    verifiedOn: Date | null;
    parameters: InjectionMoldingKnowledgeEntry[];
    files: UploadedFile[];
    changeLog: InjectionMoldingMoldChangeLog[];
    createdById: string;
    createdOn: Date;
    updatedById: string;
    updatedOn: Date;
    releasedById: string | null;
    releasedOn: Date | null;
    releaseComment: string;
}

export enum InjectionMoldingMoldStatus {
    Active = 'Active',
    Repair = 'Repair',
    Storage = 'Storage',
    Shipped = 'Shipped',
    Retired = 'Retired',
}

export enum InjectionMoldingMoldSetupStatus {
    Draft = 'Draft',
    Released = 'Released',
    Retired = 'Retired',
}

export enum InjectionMoldingMoldSetupConfidence {
    Unverified = 'Unverified',
    Estimated = 'Estimated',
    Confirmed = 'Confirmed',
}
